import { render, staticRenderFns } from "./TarefaDetalhe.vue?vue&type=template&id=923bdd86&scoped=true&"
import script from "./TarefaDetalhe.vue?vue&type=script&lang=js&"
export * from "./TarefaDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./TarefaDetalhe.vue?vue&type=style&index=0&id=923bdd86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bdd86",
  null
  
)

export default component.exports